import React from 'react';
import { Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { PhoneUtil } from 'utils';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const UserDestination = ({ label, user_id, username, icon, type, active }) => {
    const hasUser = !!user_id && !!username
    return (
        <div style={active === false ? {opacity:0.5} :{}}>
            <Icon className={icon} style={{marginRight: 5}}/>
            {hasUser ? (
                <>
                    <RestrictedView type='link' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                        <Link to={`/settings/users/${user_id}/${type === "direct_extension" ? "general" : "integration/phone"}`}>{username}</Link>
                    </RestrictedView>
                    <div>
                        {label}
                    </div>
                </>
            ) : label}
        </div>
    )
}

const OtherDestination = ({ label, icon, url }) => {
    return (
        <>
            {!!icon && <Icon className={icon} style={{marginRight: 5}}/>}
            {!!url && <RestrictedView type='link' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}><Link to={`${url}?search=${label}`}>{label}</Link></RestrictedView>}
        </>
    )
}

const Destinations = ({ destination = {} }) => {
    const { label, type, user_id, username,active=undefined } = destination;
    if (type === "direct_extension" || type === "personal_voicemail") {
        return <UserDestination 
            label={label} 
            user_id={user_id} 
            username={username} 
            icon={PhoneUtil.DESTINATION_TYPES_ICONS[type]}
            type={type}
            active={active}
        />
    }

    return <OtherDestination label={label} icon={PhoneUtil.DESTINATION_TYPES_ICONS[type]} url={PhoneUtil.DESTINATION_TYPES_URLS[type]} />;
}

export default Destinations;